import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  public user$: Observable<any> = this.authSvc.afAuth.user;
  public user = this.authSvc.afAuth.user;
  usuario: any;
  perfil: any;
  usrType: string;
  nombre: string;
  constructor(private prodSvc: ProductosService,
              private route: Router,
              private authSvc: AuthService) {
    this.loadStorage();
   }
  lista: any;
  cantidad$: Observable<any>;

  ngOnInit(): void {
    this.loadUserStorage();
    this.loadStorage();
   /*  this.user.subscribe(usr => {
      this.usuario = usr;
      if (this.usuario !== null) {
        const idUser = this.usuario.uid;
        this.authSvc.consultarTipoUsuario(idUser)
        .subscribe(res => {
          this.perfil = res;
          const tipo = this.perfil.tipo;
          this.nombre = this.perfil.nombre;
          this.usrType = tipo;
        });
      }
    }); */
  }

  loadUserStorage(){
    if (localStorage.getItem('dataUserSupedido')) {
      this.usuario = JSON.parse( localStorage.getItem('dataUserSupedido'));
      this.perfil = this.usuario;
      this.nombre = this.usuario.nombre;
      this.usrType = this.usuario.tipo;
    }
  }

  openCar(){
    this.route.navigate([`/compras`]);
  }

  loadStorage(){
    if (localStorage.getItem('data')) {
      this.lista = JSON.parse( localStorage.getItem('data'));
      this.cantidad$ = this.lista.length;
    }
  }

  onLogout(){
    Swal.fire({
      title: 'Salir del catálogo?',
      text: 'Vas a cerrar tu sesión?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, cerrar'
    }).then((result) => {
      if (result.value) {
        try {
          this.authSvc.logout();
          this.route.navigate(['home']);
          // window.location.href = 'https://supedido.co/';
        } catch (error) {
          console.log(error);
        }
        Swal.fire(
          'Sesión finalizada!',
          'Te esperamos de nuevo.',
          'success'
        );
      }
    });
   }
   salirCatalogo(){
    window.location.href = 'https://supedido.co/';
   }


}
